import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";

export const SUPPORT_EMAIL = "faye@futuregenservices.com";

export const CANCEL_ROUTE = `Cancel in two clicks from Billing → Cancel, or by emailing ${SUPPORT_EMAIL} — no phone call or notice period. Cancellations take effect at the end of the paid period (or the minimum term, where one applies).`;
export const AUTO_RENEWAL = "Plans renew automatically — monthly or annually, whichever you choose — at the same price until you cancel.";
export const VAT_NOTE = "Prices are in GBP and are the amount you pay — we are not VAT registered, so no VAT is added.";
export const MISSED_PAYMENT = "If a payment fails we retry and email you for 14 days while your access continues. If it is still unpaid after 14 days the subscription ends and any remaining minimum term stays payable.";

export const STANDARD_TERMS = [
  "14-day free trial — card taken now, nothing charged for 14 days; cancel during the trial and pay nothing.",
  "3-month minimum paid term from the end of the trial. If you cancel inside it, the remainder of the term remains payable. An annual payment satisfies the term.",
  AUTO_RENEWAL,
  CANCEL_ROUTE,
  MISSED_PAYMENT,
  VAT_NOTE,
];

export const FOUNDER_TERMS = [
  "You pay from day one at 50% off — there is no free trial on the Club route. Renewals stay at the same 50% discounted rate for as long as you stay fully subscribed.",
  "12-month minimum term from your first payment. An annual payment satisfies it.",
  "Cancelling inside the 12-month term forfeits your 50% discount and your Founders Club place — permanently. After 12 months you can cancel at any time and the discount simply continues while you stay fully subscribed.",
  "100 places only — 20 per speciality. One place per registered location; multi-site groups may hold a place for each location. Places are personal to the organisation and cannot be transferred.",
  `${MISSED_PAYMENT} A lapse also forfeits your discount and place, but you may reclaim them if you resubscribe within 30 days; after that, resubscribing is at standard prices.`,
  AUTO_RENEWAL,
  CANCEL_ROUTE,
  VAT_NOTE,
];

export function PlanTerms({ founder = false, className = "" }) {
  const items = founder ? FOUNDER_TERMS : STANDARD_TERMS;
  return (
    <div className={`rounded-2xl border border-border bg-secondary/40 p-5 text-left ${className}`} data-testid={founder ? "plan-terms-founder" : "plan-terms-standard"}>
      <p className="font-display font-semibold text-sm mb-2">{founder ? "Founders Club terms — please read before you pay" : "Subscription terms — please read before you pay"}</p>
      <ul className="space-y-1.5 text-xs text-muted-foreground list-disc pl-4">
        {items.map((t, i) => <li key={i} className={founder && i === 2 ? "text-rose-700 font-medium" : ""}>{t}</li>)}
      </ul>
    </div>
  );
}

export function ForfeitureAcknowledgement({ checked, onChange }) {
  return (
    <label className="flex items-start gap-2.5 rounded-xl border border-rose-200 bg-rose-50 p-3 text-xs text-rose-900 cursor-pointer" data-testid="founder-forfeit-ack">
      <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid="founder-forfeit-ack-checkbox" />
      <span>I understand that I pay from day one with no free trial, that there is a 12-month minimum term, and that cancelling inside that term forfeits my 50% discount and my Founders Club place.</span>
    </label>
  );
}

export function useForfeitAck() {
  return useState(false);
}
